import React, {Fragment} from 'react';

import { processResponse, activePageFormat} from '../../../utilities/processResponse';

import './Section.css';

const section = (props) => {
    var tempSection = props.html;
    const { substitutions } = props;
    const isAvailable = tempSection.includes('{');
    const activePageNumber = props.activePageNumber !== undefined ? props.activePageNumber : "";
    const lastPageNumber = props.lastPageNumber !== undefined ? props.lastPageNumber : "";
    const sectionSubstitutions = {
        ...substitutions,
        activePageNumber,
        lastPageNumber
    };    
    const content = tempSection.replace(/{%=(.*?)%}/g, (match, p1) => {
        const key = p1.trim().toLowerCase();
        const sectionSubstitutionKey = Object.keys(sectionSubstitutions).find(k => k.toLowerCase() === key.toLowerCase());
        return sectionSubstitutionKey !== undefined ? sectionSubstitutions[sectionSubstitutionKey] : match;
    });   
    return (
        <Fragment>
            {
                props.type === "pre" ?
                    <div
                        className={`${props.className !== null ? props.className : ""} section-contain`}
                        dangerouslySetInnerHTML={{__html: processResponse(content, substitutions)}}
                    ></div>
                :
                    <div
                        className={`${props.className !== null ? props.className : ""} section-contain`}
                        dangerouslySetInnerHTML={{__html: isAvailable ? processResponse(props.html, substitutions) : props.html}}
                    ></div>
            }
        </Fragment>

    );
}

export default section;
